<template>
  <div class="ld" v-if="isShow.isLDShow">
    <div class="wrap">
      <div class="circle" ref="circle">
        <div class="percent left" :style="`transform: ${leftStyle}`" ref="left"></div>
        <div class="percent right wth0" ref="right"></div>
      </div>
      <div class="ld-bell"></div>
    </div>
    <div class="num">
      <span>{{ loadingNum }}%</span>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Loading',
  props: {
    isShow: Object
  },
  data() {
    return {
      loadingNum: 0,
      leftStyle: '',
      preLoadImg: [{"src":require('../../pages/loading/img/ld-bell.png')},{"src":require('../../pages/loading/img/ld-bg.png')},{"src":require('../../pages/paegKV/img/kv-bg.jpg')},{"src":require('../../pages/paegKV/img/kv-desk.png')},{"src":require('../../pages/paegKV/img/kv-rank.png')},{"src":require('../../pages/paegKV/img/kv-start.png')},{"src":require('../../pages/paegKV/img/kv-store.png')},{"src":require('../../pages/paegKV/img/kv-title1.png')},{"src":require('../../pages/paegKV/img/kv-title2.png')},{"src":require('../../pages/pageOne/img/pop-btn.png')},{"src":require('../../pages/pageOne/img/pop-camera.png')},{"src":require('../../pages/pageOne/img/pop-camera1.png')},{"src":require('../../pages/pageOne/img/pop-camera2.png')},{"src":require('../../pages/pageOne/img/pop-coin.png')},{"src":require('../../pages/pageOne/img/pop-pos1.png')},{"src":require('../../pages/pageOne/img/pop-pos2.png')},{"src":require('../../pages/pageOne/img/pop-pos3.png')},{"src":require('../../pages/pageOne/img/pop-pos4.png')},{"src":require('../../pages/pageOne/img/pop-pos5.png')},{"src":require('../../pages/pageOne/img/pop-shadow.png')},{"src":require('../../pages/pageOne/img/save1.png')},{"src":require('../../pages/pageOne/img/save2.png')},{"src":require('../../pages/pageOne/img/save3.png')},{"src":require('../../pages/pageOne/img/save4.png')},{"src":require('../../pages/pageOne/img/save5.png')},{"src":require('../../pages/pageOne/img/test-bg.jpg')},{"src":require('../../pages/pageOne/img/test-blackboard.png')},{"src":require('../../pages/pageOne/img/test-clock.png')},{"src":require('../../pages/pageOne/img/test-cross.png')},{"src":require('../../pages/pageOne/img/test-desk.png')},{"src":require('../../pages/pageOne/img/test-num.png')},{"src":require('../../pages/pageOne/img/test-opt-bg.png')},{"src":require('../../pages/pageOne/img/test-tick.png')}]
    }
  },
  mounted() {
    let imgID = 0
    this.loadNextImg(imgID)
    this.startLoading()
  },
  methods: {
    showNext() {
      this.$emit('nextPage', 'isKVShow')
    },
    generateId(index) {
      return 'mImg' + index
    },
    loadNextImg(imgID) {
      const _this = this
      const len = this.preLoadImg.length
      const curSrc = this.preLoadImg[imgID].src
      let curImg = new Image()
      curImg.onload = function () {
        imgID++
        _this.loadingNum = parseInt((imgID / len) * 100)
        if (imgID < len) {
          _this.loadNextImg(imgID)
        } else {
          _this.showNext()
        }
      }
      curImg.src = curSrc
    },
    startLoading() {
      const rightEle = this.$refs.right
      const circleEle = this.$refs.circle
      const loading = setInterval(() => {
        this.leftStyle = `rotate(${(18/5)*this.loadingNum}deg)`
        if (this.loadingNum >= 100) {
          clearInterval(loading)
          this.showNext()
        } else if (this.loadingNum > 50) {
          circleEle.classList.add('clip-auto')
          rightEle.classList.remove('wth0')
        }
        this.loadingNum++
      }, 20)
    }
  }
}
</script>

<style lang="less" scoped>
.ld {
  height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  background-image: url('./img/ld-bg.png');
  background-size: contain;
  background-position-y: center;
}
.ld-bell {
  width: 8.75/2rem /* 140/16 */;
  height: 10.625/2rem /* 170/16 */;
  background-image: url('./img/ld-bell.png');
  background-size: cover;
  background-repeat: no-repeat;
}
.wrap, .circle, .percent {
  width: 8.125rem /* 130/16 */;
  height: 8.125rem /* 130/16 */;
  border-radius: 50%;
}
.circle, .percent {
  position: absolute;
}
.wrap {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #fefefe;
}
.percent {
  box-sizing: border-box;
}
.circle {
  box-sizing: border-box;
  clip: rect(0, 8.125rem, 8.125rem, 4.0625rem);
}
.clip-auto {
  clip: rect(auto, auto, auto, auto);
}
.left {
  transition: transform ease;
  border: .25rem /* 4/16 */ solid #00b3ea;
  clip: rect(0, 4.0625rem, 8.125rem, 0);
}
.right {
  border: .25rem solid #00b3ea;
  clip: rect(0, 8.125rem, 8.125rem, 4.0625rem);
}
.wth0 {
  width: 0;
}
.num {
  margin-top: .625rem /* 10/16 */;
  margin-bottom: 6rem;
  font-size: 1rem;
  line-height: 1.8;
  text-align: center;
}
</style>